import api from "./index";

export const inventoryAPI = {
  // Materials
  getMaterials: (params) => api.get("/inventory/materials", { params }),
  getMaterialById: (id) => api.get(`/inventory/materials/${id}`),
  createMaterial: (data) => api.post("/inventory/materials", data),
  updateMaterial: (id, data) => api.put(`/inventory/materials/${id}`, data),
  deleteMaterial: (id) => api.delete(`/inventory/materials/${id}`),

  // Locations
  getLocations: (params) => api.get("/inventory/locations", { params }),
  createLocation: (data) => api.post("/inventory/locations", data),
  updateLocation: (id, data) => api.put(`/inventory/locations/${id}`, data),

  // Stock
  getStock: (params) => api.get("/inventory/stock", { params }),
  getStockByLocation: (locationId) => api.get(`/inventory/stock/${locationId}`),
  transferStock: (data) => api.post("/inventory/stock/transfer", data),
  consumeStock: (data) => api.post("/inventory/stock/consume", data),
  getLowStock: () => api.get("/inventory/low-stock"),
  getTransactions: (params) => api.get("/inventory/transactions", { params }),
};
